import { IconButton, styled } from "@mui/material";
import { useEffect, useState } from "react";

import { MarketFavorite } from "store/api/market";
import http from "config/http";
import useNotify from "hooks/useNotify";

export function BookmarkCoin({ data, size }) {
  const notify = useNotify();
  const [isFavorite, setIsFavorite] = useState(data?.isFavorite);

  useEffect(() => {
    setIsFavorite(data?.isFavorite);
  }, [data]);

  const handleIsFavorite = async () => {
    try {
      const body = {
        coinSourceId: data?.coinSourceId,
        coinDestinationId: data?.coinDestinationId,
        isRemove: data?.isFavorite,
      };
      await http.post(MarketFavorite, body);
      setIsFavorite((v) => !v);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  return (
    <IconButtonBookmark size={size} onClick={handleIsFavorite}>
      <ion-icon name={isFavorite ? "bookmark" : "bookmark-outline"} />
    </IconButtonBookmark>
  );
}

export const IconButtonBookmark = styled(IconButton)(({ size, theme }) => ({
  "ion-icon": {
    position: "relative",
    transform: "rotate(-90deg)",
    fontSize: size || "16px",
    color: theme.palette.error.main,
  },
}));

export default BookmarkCoin;
